<template>
    <nav class="navbar navbar-expand-lg text-uppercase fixed-top" id="mainNav">
        <div class="container">
            <RouterLink class="navbar-brand" :to="{ name: 'home', hash: '#topbar' }">
                <span class="fa-stack fa-1x" id="navSpin">
                    <i class="fas fa-gear fa-stack-2x text-white"></i>
                    <i class="fas fa-globe fa-sm fa-stack-1x text-info bg-white"></i>
                </span> TecWeb
            </RouterLink>
            <button class="navbar-toggler text-uppercase font-weight-bold bg-info shadow text-white rounded"
                type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive"
                aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                Menú
                <i class="fas fa-bars"></i>
            </button>
            <div class="collapse navbar-collapse" id="navbarResponsive">
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item mx-0 mx-lg-1">
                        <RouterLink class="nav-link py-3 px-0 px-lg-3 rounded" to="/#services"
                            title="Principales Servicios">Servicios</RouterLink>
                    </li>
                    <li class="nav-item mx-0 mx-lg-1">
                        <RouterLink class="nav-link py-3 px-0 px-lg-3 rounded" to="/#portfolio"
                            title="Portafolio de proyetos">Proyectos</RouterLink>
                    </li>
                    <li class="nav-item mx-0 mx-lg-1">
                        <RouterLink class="nav-link py-3 px-0 px-lg-3 rounded" to="/#contact"
                            title="Envianos un Mensaje">Contacto</RouterLink>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
<style scoped>
#navSpin {
    --fa-animation-duration: 3s;
    --fa-animation-iteration-count: 1;
}
</style>
<script setup>
import { onMounted } from 'vue';
//import {RouterLink} from 'vue-router';
import * as bootstrap from 'bootstrap';


onMounted(() => {

    var navbarShrink = function () {
        const navbarCollapsible = document.body.querySelector("#mainNav");
        const navSpin = document.body.querySelector("#navSpin");
        if (!navbarCollapsible) {
            return;
        }

        if (window.scrollY === 0) {
            navbarCollapsible.classList.remove("navbar-shrink");
            navSpin.classList.remove("fa-spin");
        } else {
            navbarCollapsible.classList.add("navbar-shrink");
            navbarCollapsible.classList.add("bg-info");
            navSpin.classList.add("fa-spin");
        }
    };

    // Shrink the navbar
    setTimeout(navbarShrink(), 200);

    // Shrink the navbar when page is scrolled
    document.addEventListener("scroll", navbarShrink);
    const mainNav = document.body.querySelector("#mainNav");
    if (mainNav) {
        new bootstrap.ScrollSpy(document.body, {
            target: "#mainNav",
            rootMargin: "0px 0px -40%",
        });
    }
    // Collapse responsive navbar when toggler is visible
    const navbarToggler = document.body.querySelector(".navbar-toggler");
    const responsiveNavItems = [].slice.call(
        document.querySelectorAll("#navbarResponsive .nav-link")
    );

    responsiveNavItems.map(function (responsiveNavItem) {
        responsiveNavItem.addEventListener("click", () => {
            if (window.getComputedStyle(navbarToggler).display !== "none") {
                navbarToggler.click();
            }
        });
    });
});
</script>